module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/covid_measures/2@2x_c2a8a26a06d07d9ee69741c820420e2c.png";